module.exports = __webpack_public_path__ + "img/41_30.88010ae9.png";